import React from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

/**
 * Generic error placeholder for dashboard pages/sections.
 *
 * Renders a centered icon + title + message, with an optional retry action.
 * Callers pass already-translated strings so the component stays presentational.
 */
export default function ErrorState({ icon, title, message, actionLabel, onRetry }) {
  return (
    <Stack
      flex={1}
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ py: 6, textAlign: 'center' }}
    >
      {icon ?? <ErrorOutlineIcon color="error" sx={{ fontSize: 48 }} />}
      {title && <Typography variant="h6">{title}</Typography>}
      {message && (
        <Typography color="text.secondary" sx={{ maxWidth: 420 }}>
          {message}
        </Typography>
      )}
      {onRetry && actionLabel && (
        <Button variant="outlined" onClick={onRetry}>
          {actionLabel}
        </Button>
      )}
    </Stack>
  );
}
